// 离线队列 - 用 localStorage 暂存
import { storage } from './storage'
import { uuid } from './format'
import type { RecordType } from './types'

const QUEUE_KEY = 'record_queue'
const MAX_QUEUE = 50

export interface PendingRecord {
  client_uuid: string
  type: RecordType
  occurred_at: number
  note?: string
  attempts: number
  last_error?: string
}

function load(): PendingRecord[] {
  return storage.get<PendingRecord[]>(QUEUE_KEY) || []
}

function save(items: PendingRecord[]) {
  storage.set(QUEUE_KEY, items.slice(-MAX_QUEUE))
}

export const offline = {
  // 推入队列。client_uuid 不传则自动生成。
  enqueue(input: { type: RecordType; occurred_at: number; note?: string; client_uuid?: string }): PendingRecord {
    const item: PendingRecord = {
      client_uuid: input.client_uuid || uuid(),
      type: input.type,
      occurred_at: input.occurred_at,
      note: input.note,
      attempts: 0,
    }
    const items = load()
    items.push(item)
    save(items)
    return item
  },

  list(): PendingRecord[] {
    return load()
  },

  remove(client_uuid: string) {
    save(load().filter((it) => it.client_uuid !== client_uuid))
  },

  markFailed(client_uuid: string, error: string) {
    const items = load().map((it) =>
      it.client_uuid === client_uuid ? { ...it, attempts: it.attempts + 1, last_error: error } : it
    )
    save(items)
  },

  count(): number {
    return load().length
  },

  clear() {
    save([])
  },
}
